import { createContext, useReducer } from "react";

export const CatalogCategoriesContext = createContext();

export const categoryReducer = (state, action) => {
  switch (action.type) {
    case "SET_CATEGORIES":
      return {
        categories: action.payload,
        locale: action.locale ?? state.locale,
      };
    case "CREATE_CATEGORY":
      return {
        categories: [action.payload, ...state.categories],
      };
    case "DELETE_CATEGORY":
      return {
        categories: state.categories.filter(
          (c) => c._id !== action.payload._id
        ),
      };
    default:
      return state;
  }
};

export const CatalogCategoriesContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(categoryReducer, {
    categories: null,
    locale: null,
  });

  return (
    <CatalogCategoriesContext.Provider value={{ ...state, dispatch }}>
      {children}
    </CatalogCategoriesContext.Provider>
  );
};
